
import { Vue, Component, Prop } from 'vue-property-decorator'
import setting from '@/settings'

@Component({
  name: 'preview-temp1'
})

export default class PreviewTemp1 extends Vue {
  private setting = setting

  private imageClass = ['single', 'double', 'three', 'four']

  private srcs = {
    share: require('@/assets/statics/pics/share.png'),
    link: require('@/assets/statics/pics/link.png'),
    pic: require('@/assets/statics/pics/pic.png'),
    wechat: require('@/assets/statics/pics/wechat.png'),
    book: require('@/assets/statics/pics/book.png')
  }

  // 简章信息
  @Prop({ type: Array })
  private instrs!: any[]

  // 基础信息
  @Prop({ type: Object })
  private data!: {}|any

  @Prop({ type: String })
  private logo!: string

  get labels () {
    return this.data.labelName ? this.data.labelName.split(',') : []
  }
}
